"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Heading = _interopRequireDefault(require("../../text/Heading5"));

var _Caption = _interopRequireDefault(require("../../text/Caption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledImage = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "mu8cht-0"
})(["border-radius:50%;width:40px;height:40px;background-size:40px;background-image:url(", ");"], function (props) {
  return props.src;
});

function Avatar(_ref) {
  var className = _ref.className,
      title = _ref.title,
      subTitle = _ref.subTitle,
      src = _ref.src,
      color = _ref.color;
  return _react["default"].createElement(_pclnDesignSystem.Flex, null, _react["default"].createElement(StyledImage, {
    src: src,
    color: color,
    p: 2
  }, !src && _react["default"].createElement(_pclnDesignSystem.Icon, {
    className: className,
    name: "user"
  })), title && _react["default"].createElement(_pclnDesignSystem.Flex, {
    flexDirection: "column",
    ml: 3
  }, _react["default"].createElement(_Heading["default"], null, title), _react["default"].createElement(_Caption["default"], {
    subdued: true
  }, subTitle)));
}

Avatar.displayName = 'Avatar';
Avatar.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  src: _propTypes["default"].string,
  color: _propTypes["default"].string
};
Avatar.defaultProps = {
  className: '',
  color: 'primary'
};

var _default = (0, _react.memo)(Avatar);

exports["default"] = _default;